var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.label,attrs:{"href":_vm.url,"target":"_blank"}},[_c(_vm.$props.tag,{tag:"component",staticClass:"gem",class:( _obj = {}, _obj[("bg-" + _vm.color)] = 1, _obj )},[_c('img',{staticClass:"mx-auto",attrs:{"src":_vm.sourceUrl,"alt":_vm.altText}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }